import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Asset} from '..';
import { Validation } from '../../../tools';
import { AssetList } from '../models/asset-list.model';
import { AppConfigProvider } from '../../../app-config.provider';
import { ID } from '@datorama/akita';
import { AssetModel } from '../../akita';

export class AssetService {
  private readonly assetBaseUrl: string;
  private readonly baseUrl: string;

  constructor(private readonly httpClient: HttpClient, private appConfigProvider: AppConfigProvider) {
    this.assetBaseUrl = this.appConfigProvider.getAssetsBaseUrl();
    this.baseUrl = this.appConfigProvider.getApiEndpoint();
  }

  getByQuery(queryPatameters: any): Observable<AssetList> {
    const url = `${this.assetBaseUrl}${queryPatameters}`;
    return this.httpClient.get(url) as Observable<AssetList>;
  }

  getById(assetId: any): Observable<Asset> {
    const url = `${this.assetBaseUrl}/${assetId}`;
    return this.httpClient.get(url) as Observable<Asset>;
  }

  upload(formData: FormData): Observable<Asset> {
    if (formData) {
      const url = `${this.assetBaseUrl}`;
      return this.httpClient.post(url, formData) as Observable<Asset>
    } else {
      throw (new Error('data is null when trying to create asset'));
    }
  }

  update(assetId: any, assetData: any): Observable<Asset> {
    const url = `${this.assetBaseUrl}/${assetId}`;
    return this.httpClient.put(url, assetData) as Observable<Asset>;
  }

  updateTag(assetId: string, assetData: any): Observable<Asset> {
    const url = `${this.assetBaseUrl}/${assetId}`;
    return this.httpClient.put(url, assetData) as Observable<Asset>;
  }

  updateParent(assetId: string, assetData: any): Observable<Asset> {
    const url = `${this.assetBaseUrl}/${assetId}/parent`;
    return this.httpClient.put(url, assetData) as Observable<Asset>;
  }

  delete(assetId: ID): Observable<Asset> {
    if (Validation.isValidGuid(String(assetId))) {
      const url = `${this.assetBaseUrl}/${assetId}`;
      return this.httpClient.delete(url) as Observable<Asset>;
    } else {
      throw (new Error('Guid is not valid when trying to delete asset'));
    }
  }

  find(oDataQuery: string): Observable<Asset[]> {
    const url = `${this.assetBaseUrl}${oDataQuery}`;
    return this.httpClient.get(url) as Observable<Asset[]>;
  }


  countQuery(oDataQuery: string): Observable<number> {
    return this.find(oDataQuery)
      .pipe(map(asset => asset['total']));
  }


  generateThumbnail(pageUrl: string, pageName: string, imageId?: string): Observable<any> {

    return of(true);
    let url = document.location.origin + '/capture/get';
    url += encodeURI(`?url=${pageUrl}&imageName=${pageName}${(imageId ? '&parentId='+imageId : '')}` );
    return this.httpClient.get(url) as Observable<any>;
  }


  count(): Observable<Number> {
    return this.find('?$top=1')
      .pipe(map(asset => asset['total']));
  }

  getCount(folderId: any): Observable<AssetList> {
    const url = `${this.assetBaseUrl}?parentId=${folderId}&$top1`;
    return this.httpClient.get(url) as Observable<AssetList>;
  }


  getAllOrdered(orderBy: string = 'id') {
    const url = `${this.assetBaseUrl}?$orderby=${orderBy}`;
    return this.httpClient.get(url) as Observable<Asset[]>;
  }

  convertObjectToUrl(urlObject: object) {
    return urlObject;
  }

}
